/* eslint-disable @typescript-eslint/no-var-requires */

// Basic I18n data modules
import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';
export const i18nSetup = () => {
  // Require in all timezone data if requested
  // @ts-expect-error $quartzConfigVal's types can't be narrowed, so any app-only config fields present as type errors
  if (undefined) {
    require('I18n/init/data/allTimezones');
  }

  // @ts-expect-error $quartzConfigVal's types can't be narrowed, so any app-only config fields present as type errors
  if ("sync" === 'sync') {
    return require('i2l?mode=sync!$host-package-base-dir/lang/en.lyaml').default;
    // @ts-expect-error $quartzConfigVal's types can't be narrowed, so any app-only config fields present as type errors
  } else if ("sync" === 'very-lazy') {
    return require('i2l?mode=very-lazy!$host-package-base-dir/lang/en.lyaml').default;
  } else {
    return require('i2l?mode=lazy!$host-package-base-dir/lang/en.lyaml').default;
  }
};